const styles = theme => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1,
    },
    main: {
        // marginTop : "25px",
    },
    spacer: {
        padding: "10px",
    },
});

export default styles;